import { Step } from 'signup-constants/Step';
export let CopyKey;
(function (CopyKey) {
  CopyKey["Default"] = "default";
  CopyKey["Loading"] = "loading";
  CopyKey["Analyzing"] = "analyzing";
  CopyKey["Success"] = "success";
  CopyKey["Error"] = "error";
  CopyKey["NoInfoFound"] = "noInfoFound";
  CopyKey["NoInfoFoundSidePanel"] = "noInfoFoundSidePanel";
  CopyKey["SuccessSidePanel"] = "successSidePanel";
  CopyKey["ErrorSidePanel"] = "errorSidePanel";
})(CopyKey || (CopyKey = {}));
const translationKeyPrefix = `views.${Step.CompanyDomain}.breezeHelperText`;
export const config = {
  [CopyKey.Default]: `${translationKeyPrefix}.default`,
  [CopyKey.Loading]: `${translationKeyPrefix}.loading`,
  [CopyKey.Analyzing]: `${translationKeyPrefix}.analyzing`,
  [CopyKey.Success]: `${translationKeyPrefix}.success`,
  [CopyKey.SuccessSidePanel]: `${translationKeyPrefix}.successSidePanel`,
  [CopyKey.Error]: `${translationKeyPrefix}.error`,
  [CopyKey.ErrorSidePanel]: `${translationKeyPrefix}.errorSidePanel`,
  [CopyKey.NoInfoFound]: `${translationKeyPrefix}.noWebsite`,
  [CopyKey.NoInfoFoundSidePanel]: `${translationKeyPrefix}.noWebsiteSidePanel`
};